import { render, staticRenderFns } from "./InactivationsResolvedList.vue?vue&type=template&id=4a05d1e8&"
import script from "./InactivationsResolvedList.vue?vue&type=script&lang=js&"
export * from "./InactivationsResolvedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports